import React from 'react';

import DashBoard from 'components/analyticDashboard';

const AnalyticDashboard = () => <DashBoard />;

export default AnalyticDashboard;
